import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fromEvent, Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators';
import { RecruiterServices } from '../shared/services/recruiter.services';
import { RoleService } from '../shared/services/role-service/role.service';


export interface State {
  name: string;
  url: string;
  type: string;
}

@Component({
  selector: 'global-search',
  templateUrl: './global-search.component.html',
  styleUrls: ['./global-search.component.scss']
})
export class GlobalSearchComponent implements OnInit, AfterViewInit {

  public stateCtrl = new FormControl();
  public filteredStates: Observable<State[]>;
  public keyData: string = '';
  public accessRoles:any;

  @ViewChild('globalSearchBox') globalSearchBox!: ElementRef;

  constructor(private router: Router,
    private recruiterServices: RecruiterServices,
    public roleService: RoleService,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    console.log("Global Search Component Init");
    this.accessRoles = this.roleService.getRoles();

    this.activatedRoute.queryParams.subscribe((query) => {
      this.keyData = '';
      // console.log("keyData in global search", this.keyData);
      if (query.key) {
        this.keyData = query.key;
        this.stateCtrl.setValue(this.keyData);
      } else {
        this.stateCtrl.setValue(this.keyData);
        this.filteredStates = null;
      }
    });
  }

  ngAfterViewInit() {
    const inputEl = this.globalSearchBox.nativeElement as HTMLInputElement;

    const typeahead = fromEvent<KeyboardEvent>(inputEl, 'input').pipe(
      map((e: KeyboardEvent) => (<HTMLInputElement>e.target).value),
      filter(text => text.length > 2),
      debounceTime(500),
      distinctUntilChanged(),
    );

    typeahead.subscribe(keyword => {
      this.recruiterServices.getGlobalSearch(keyword).subscribe(data => {
        console.log("Global Search Data:", data);
        if (data.result) {
          this.filteredStates = of(data.result);
        }
      });
    });
  }



  // public searchBox = document.getElementById('global-search-box');

  // ngOnInit() {
  //   this.accessRoles = this.roleService.getRoles();
  //   // console.log('check voc access roles',this.accessRoles);
  //   this.activatedRoute.queryParams.subscribe((query) => {
  //     this.keyData = '';
  //     console.log("keyData in global search", this.keyData);
  //     if (query.key) {
  //       this.keyData = query.key;
  //       this.stateCtrl.setValue(this.keyData);
  //     } else {
  //       this.stateCtrl.setValue(this.keyData);
  //       this.filteredStates = null;
  //     }
  //   });

  //   const typeahead = fromEvent<KeyboardEvent>(document.querySelector('#global-search-box') as HTMLInputElement , 'input').pipe(
  //     map((e: KeyboardEvent) => {return  (<HTMLInputElement>e.target).value}),
  //     filter(text => text.length > 2),
  //     debounceTime(500),
  //     distinctUntilChanged(),
  //   );

  //   typeahead.subscribe(keyword => {
  //         this.recruiterServices.getGlobalSearch(keyword).subscribe(data => {
  //           if (data.result)
  //             this.filteredStates = of(data.result);
              
  //         });
  //   });
  // }


  gotoSearchpage(type: any, id: any, keyName: any, state?:any) {

    let gloableSearch = 0;
    let url: string;

    console.log("type,id,keyName", type, id, keyName);
    if (type == "project") {
      url = '/home/projects/' + id;
      window.location.href = url + '/?key=' + keyName;

    } else if (type == "study") {
      if (state.studyMode === 'qual') {
        // localStorage.setItem('studyId',id);
        sessionStorage.setItem('studyId',id);
        localStorage.setItem('studyTYPE','qual');
        // sessionStorage.setItem('studyTYPE','qual');
        url = '/qual/interview/' + id;
        window.location.href = url ;
      }else{
        url = '/home/performance-tracker/' + id;
        window.location.href = url + '/?key=' + keyName;
        localStorage.setItem('studyTYPE','home');
        // sessionStorage.setItem('studyTYPE','home');
      }

    } else if (type == "PT") {
      let url = "/home/product-testing/" + id;
      window.location.href = url;
      // localStorage.setItem('studyTYPE','home');
      // this.router.navigate([url], { queryParams: { gloableSearch: gloableSearch, id: id } });
    }else if (type == "recruiter") {
      let url = "/home/recruiters";
      gloableSearch = 1;
      this.router.navigate([url], { queryParams: { gloableSearch: gloableSearch, id: id } });
    }
  }

  changeToElip(str: string): string {
    if (str.length > 32) {
      str = str.slice(0, 32) + '...';
    }
    return str;
  }

}
